const getDialogProps = (rootState) => rootState.ui.dialogs.activeDialog.dialogProps;

export default getDialogProps;
